import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  ADD_PARTS
} from 'redux/actions/index';
import { Part } from 'models/Part';

import ActionButton from 'components/ActionButton';

import '../../../node_modules/@fortawesome/fontawesome-free/css/all.min.css';
import './ManageOrder.css';


class ManageOrder extends Component {
  state = {
    partsAdded: false
  };

  onAddParts = () => {
    const { partsList, addPartsToOrder } = this.props;
    addPartsToOrder(partsList);
    this.setState({
      partsAdded: true
    });
  };

  render() {
    const { partsAdded } = this.state;
    const { getString, order } = this.props;
    return (
      <div className="add-list">
        <div className="row">
          <div className="col-md-16 col-sm-24">
            <h2 className="block-head">
              <span className="number">
                4
              </span>
              <span>
                {getString('add-to-list', 'general')}
              </span>
            </h2>
          </div>
          <div className="col-md-4 col-sm-12">
            <ActionButton onHandleClick={this.onAddParts} enabled={!partsAdded}>
              <i className="fa fa-plus" />
            </ActionButton>
          </div>
          <div className="col-md-4 col-sm-12">
            {
              order.length > 0 ? (
                <Link to="/review" className="blue-btn">
                  {getString('view-list', 'general')}
                </Link>
              ) : (
                <div className="grey-btn">
                  {getString('view-list', 'general')}
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

ManageOrder.defaultProps = {};
ManageOrder.propTypes = {
  partsList: PropTypes.arrayOf(PropTypes.instanceOf(Part)).isRequired,
  addPartsToOrder: PropTypes.func.isRequired,
  getString: PropTypes.func.isRequired,
  order: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

export default withRouter(connect(
  state => ({
    getString: state.strings.getString,
    order: state.order
  }),
  dispatch => ({
    addPartsToOrder: partsList => dispatch({ type: ADD_PARTS, newParts: partsList })
  })
)(ManageOrder));
